const comments = [
  {
    name: '漫迷小樱',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20friendly%20anime%20style%20girl%20portrait%20avatar%20with%20pink%20hair%2C%20soft%20lighting%2C%20simple%20background%2C%20kawaii%20style&width=120&height=120&seq=avatar-comment-01&orientation=squarish',
    text: '妖精漫画网真的太棒了！韩漫更新超快，画质清晰，下拉式阅读体验比别的网站舒服太多了。已经推荐给身边所有喜欢看漫画的朋友！',
    manga: '恋爱幻想曲',
    time: '2小时前',
  },
  {
    name: '热血阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20portrait%20avatar%20with%20dark%20hair%2C%20warm%20lighting%2C%20simple%20background%2C%20shonen%20style&width=120&height=120&seq=avatar-comment-02&orientation=squarish',
    text: '魔导纪元追了半年了，每天准点更新从不掉链子。这个网站日漫资源是真的全，很多冷门佳作也能找到，免费的还要啥自行车。',
    manga: '魔导纪元',
    time: '5小时前',
  },
  {
    name: '书香墨韵',
    avatar: 'https://readdy.ai/api/search-image?query=A%20gentle%20anime%20style%20woman%20portrait%20avatar%20with%20long%20black%20hair%2C%20traditional%20Chinese%20aesthetic%2C%20soft%20warm%20lighting%2C%20elegant%20style&width=120&height=120&seq=avatar-comment-03&orientation=squarish',
    text: '作为一个国漫爱好者，妖精漫画网的国漫分类做得特别好。仙途无尽画面太美了，每帧都能截图当壁纸。免费网站能做到这个品质真的难得。',
    manga: '仙途无尽',
    time: '昨天',
  },
  {
    name: '夜读人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20style%20character%20portrait%20avatar%20with%20silver%20hair%2C%20night%20atmosphere%2C%20warm%20moonlight%2C%20calm%20expression&width=120&height=120&seq=avatar-comment-04&orientation=squarish',
    text: '咖啡馆奇妙夜追完了，治愈系漫画在睡前看太舒服了。妖精漫画网下拉式阅读真的丝滑，躺着刷完全没压力。已经收藏了十几部待看。',
    manga: '咖啡馆奇妙夜',
    time: '2天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">读者评论</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网读者的真实反馈，你的阅读感受对我们很重要</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((c) => (
            <div key={c.name} className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">
                    在读《{c.manga}》 · {c.time}
                  </div>
                </div>
                <div className="flex text-amber-400 text-xs">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}